import { supabase } from './client';
import { normalizeProfile } from './utils';

export const createComment = async (noteId: string, userId: string, content: string, parentId?: string) => {
  const { data, error } = await supabase
    .from('comments')
    .insert({ note_id: noteId, user_id: userId, content, parent_id: parentId })
    .select()
    .single();

  if (error) {
    console.error('Error creating comment:', error);
    throw error;
  }
  return data;
};

export const getCommentsByNoteId = async (noteId: string, limit?: number) => {
  let query = supabase
    .from('comments')
    .select('id,created_at,content,user_id,parent_id,profiles(username,avatar_url)')
    .eq('note_id', noteId)
    .order('created_at', { ascending: true }); // Prefer ascending for readable conversations

  if (limit) {
    query = query.limit(limit);
  }

  const { data, error } = await query;

  if (error) {
    console.error('Error fetching comments:', error);
    throw error;
  }
  return data.map((item: any) => ({
    ...item,
    profiles: normalizeProfile(item.profiles),
  }));
};

export const deleteComment = async (commentId: string) => {
  const { error } = await supabase
    .from('comments')
    .delete()
    .eq('id', commentId);

  if (error) {
    console.error('Error deleting comment:', error);
    throw error;
  }
};